module.exports = __webpack_public_path__ + "assets/img/Spintel-Content-Marketing.d0f74d63.jpg";